import React, { useEffect } from 'react';
import { animateScroll } from 'react-scroll';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import headerLogo from 'images/superb-logo-black.svg';
import useQuery from 'hooks/useQuery';

const Header = styled.header(() => ({
  h1: {
    fontSize: 14,
    span: {
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
}));

const Footer = styled.footer(() => ({
  small: {
    fontSize: 9,
  },
}));

export const PrivatePrintLayout = ({ children }) => {
  const query = useQuery();

  const date = query.get('date');

  const scrollToTop = () => {
    animateScroll.scrollToTop({
      duration: 300,
      smooth: true,
    });
  };

  useEffect(() => {
    const printEvent = () => {
      animateScroll.scrollToTop({
        duration: 0,
        smooth: false,
      });
    };

    window.addEventListener('beforeprint', printEvent);

    return () => {
      window.removeEventListener('beforeprint', printEvent);
    };
  }, []);

  return (
    <div className="container">
      {children}

      <Footer className="container fixed-bottom bg-white">
        <div className="d-flex align-items-center justify-content-between text-center text-small text-muted py-2 border-top">
          <img
            src={headerLogo}
            className="logo"
            alt="Footer Logo"
            className="tw-h-[20px]"
          />

          <small>
            © 2026 SUPERB INTELLIGENCE INC. CONFIDENTIAL. NOT FOR PUBLIC
            DISTRIBUTION.
          </small>
        </div>
      </Footer>
    </div>
  );
};

PrivatePrintLayout.propTypes = {
  children: PropTypes.any,
};
